import { http, type HttpClient } from './core/http-client';
import type {
  NewPlanGrant,
  PlanGrant,
  PlanGrantBusiness,
  PlanGrantDetail,
  PlanGrantOptions,
} from './models';

// Staff: free plans for sales deals. Super admins, and admins switched on for it.
export class AdminPlanGrantService {
  constructor(private readonly http: HttpClient) {}

  recent = () => this.http.get<PlanGrant[]>('/admin/plan-grants');

  options = () => this.http.get<PlanGrantOptions>('/admin/plan-grants/options');

  search = (q: string) =>
    this.http.get<PlanGrantBusiness[]>('/admin/plan-grants/businesses', { query: { q } });

  forBusiness = (businessId: string) =>
    this.http.get<PlanGrantDetail>(`/admin/plan-grants/businesses/${businessId}`);

  grant = (businessId: string, body: NewPlanGrant) =>
    this.http.post<{ id: string; planName: string; startsAt: string; endsAt: string }>(
      `/admin/plan-grants/businesses/${businessId}`,
      body,
    );

  end = (id: string, reason: string) =>
    this.http.post<{ ended: boolean }>(`/admin/plan-grants/${id}/end`, { reason });
}

export const adminPlanGrantService = new AdminPlanGrantService(http);
